// socket.js — single source of truth
import io from 'socket.io-client';
import { server } from '../Utilities/Remote';

let socket = null;

export const initSocket = () => {
  if (!socket) {
    socket = io(server, {
      transports: ['websocket', 'polling'],
      autoConnect: true,
    });
  }
  return socket;
};

export const getSocket = () => socket;

export const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
};
